<template>
  <div>
    <TsHeader data-testid="header" />

    <div>
      <slot />
    </div>

    <TsProductActions v-if="config.public.featureFlags.enableCTAAddToTrolleyBuyNow" />

    <TsProductActionsv2 v-else-if="config.public.featureFlags.enableCTACollectionDelivery" />
    <TsFooter data-testid="footer" data-fetch-key="plp-brand-layout-footer-links" />
  </div>
</template>

<script setup lang="ts">
const TsHeader = defineAsyncComponent(() => import('~/components/TsHeader.vue'));
const TsProductActions = defineAsyncComponent(
  () => import('~/components/organisms/TsProductActions.vue')
);
const TsProductActionsv2 = defineAsyncComponent(
  () => import('~/components/organisms/TsProductActionsv2.vue')
);
const TsFooter = defineAsyncComponent(() => import('~/components/TsFooter.vue'));

const config = useRuntimeConfig();
</script>
